import { render } from "./PanelAccordion.vue?vue&type=template&id=594ccb14"
import script from "./PanelAccordion.vue?vue&type=script&lang=ts"
export * from "./PanelAccordion.vue?vue&type=script&lang=ts"

import "./PanelAccordion.vue?vue&type=style&index=0&id=594ccb14&lang=scss"
script.render = render

export default script